export default __webpack_public_path__ + "SctoGroteskA-Medium.otf";